import { useCallback, useState } from "react";

import MDBox from "components/MDBox";
import MDButton from "components/MDButton";

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { ListLayout, TableCard } from "ui-components/Layout";
import { Success, Error } from "ui-components/Alert";

import { useCustomerValue } from "providers/CustomerContext";

import CheckboxTable2 from "ui-components/tables/CheckboxTable2";
import { LoadingDialog } from "ui-components/Alert";
import { useTeamValue } from "providers/TeamContext";
import { CheckboxHeader, CheckboxCell } from "ui-components/tables/components/table";
import { resendManifestEtrax } from "services/data.outbound.service";
import { getManifestEtraxList } from "services/data.outbound.service";

function ManifestEtrax() {
  const { permissions, allowAll } = useTeamValue();
  const { customerCode } = useCustomerValue();
  const enabled = Boolean(customerCode);
  const [alert, setAlert] = useState(null);
  const [data, setData] = useState([]);
  const queryClient = useQueryClient();
  const onError = (data) => setAlert(<Error data={data} onChange={setAlert} />);
  const [selectedIds, setSelectedIds] = useState([]);

  const editPermission =
    allowAll ||
    (Boolean(permissions["Manifest to eTrax"]) &&
      permissions["Manifest to eTrax"].findIndex((b) => b === "edit") !== -1);

  useQuery({
    queryKey: ["manifest-etrax-list", { customerCode }],
    queryFn: () => getManifestEtraxList({ customerCode }),
    enabled,
    onSuccess: (data) => setData(data.data.data),
    onError,
  });

  const resendMutation = useMutation(resendManifestEtrax, {
    onSuccess: (data) => {
      queryClient.invalidateQueries(["manifest-etrax-list"]);
      setAlert(<Success data={data} onChange={setAlert} />);
    },
    onError,
  });

  const columns = [
    {
      id: "select",
      header: CheckboxHeader,
      cell: CheckboxCell,
    },
    { header: "Cust Order Number", accessorKey: "custOrdNbr" },
    { header: "DO Number", accessorKey: "doNumber" },
    { header: "Error Message", accessorKey: "errorMessage" },
    {header:"Created On",accessorKey:"createdOn"},
    {header:"Updated On",accessorKey:"updatedOn"}
  ];
  const handleChange = useCallback((data) => {
    setSelectedIds(data);
  }, []);
  const onResend = () => {
    resendMutation.mutate({
      items: selectedIds.map((x) => ({ customerCode, custOrdNbr: x.custOrdNbr })),
    });
  };
  const resendStatus = resendMutation.status === "loading";
  return (
    <ListLayout>
      {resendStatus && <LoadingDialog />}
      <MDBox my={3}>{alert}</MDBox>
      <TableCard>
        <MDBox display="flex" justifyContent="space-between" alignItems="flex-start" margin="10px">
          <MDButton
            variant="gradient"
            color="info"
            onClick={onResend}
            disabled={(selectedIds.length === 0 || resendStatus) && !editPermission}
          >
            resend
          </MDButton>
        </MDBox>
        <CheckboxTable2 columns={columns} data={data} onSelectedRowsChange={handleChange} />
      </TableCard>
    </ListLayout>
  );
}

export default ManifestEtrax;
